import { PaymentPlanResource } from "@/interfaces";

/**
 * Whether this plan offers a way out of its own schedule: settle the whole
 * balance in one payment today.
 *
 * Set per plan in FolloSoft HQ, off by default. A plan spreads the money out on
 * purpose, and only the account that set it up knows whether taking the lot today
 * is acceptable.
 */
export const planAllowsPayInFull = (
  plan?: PaymentPlanResource | null
): boolean => Boolean(plan?.attributes?.is_pay_in_full_allowed);

/**
 * Whether the customer is actually settling the whole balance today.
 *
 * The offer belongs to the plan, not to the tick: the API honours `payInFull`
 * only for a plan that carries the flag, so a tick left behind by another plan
 * must not quote, price or submit as though it would be. Mirrors the
 * `$data->payInFull && $paymentPlan->allowsPayInFull()` guard on the API side.
 */
export const paysInFullNow = (
  plan: PaymentPlanResource | null | undefined,
  payInFull: boolean | undefined
): boolean => planAllowsPayInFull(plan) && Boolean(payInFull);
